import React from 'react';
import DashboardModal from '@/components/dashboard-modal';
import { useProspectForm } from './useProspectForm';
import ProspectForm from './ProspectForm';
import { EditProspectModalProps } from './types';
import { Button } from '@/components/ui/button';
import { Check, X, Loader2 } from 'lucide-react';

const EditProspectModal: React.FC<EditProspectModalProps> = ({
  isOpen,
  onClose,
  prospect,
  onUpdate
}) => {
  const {
    register,
    handleSubmit,
    onSubmit,
    resetForm,
    isPending,
    errors,
    isDirty
  } = useProspectForm({
    prospect,
    onClose,
    onUpdate
  });

  // Create a form submit handler that uses handleSubmit
  const formSubmitHandler = handleSubmit(onSubmit);

  if (!prospect) return null;

  return (
    <DashboardModal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Prospect"
      accentColor="blue"
      hasUnsavedChanges={isDirty}
      preventCloseOnUnsavedChanges={true}
      onDiscardChanges={onClose}
      onSaveChanges={formSubmitHandler}
    >
      <ProspectForm
        register={register}
        errors={errors}
        onSubmit={formSubmitHandler}
      />
      
      {/* Inline Footer Buttons */}
      <div className="flex justify-end items-center gap-2 pt-4">
        <Button 
          variant="outline"
          onClick={onClose}
          disabled={isPending}
          className="gap-1"
        >
          <X size={16} />
          Cancel
        </Button>
        <Button 
          onClick={formSubmitHandler}
          disabled={isPending}
          className="gap-1 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600"
        >
          {isPending ? (
            <>
              <Loader2 size={16} className="animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Check size={16} />
              Save Changes
            </>
          )}
        </Button>
      </div>
    </DashboardModal>
  );
};

export default EditProspectModal;
export { EditProspectModal };
